import React from 'react'
import { SignInTemplateProps } from './SignInTemplate.props'
import {
	SignInTemplateContainer,
	SignInTemplateHeaderContainer,
	SignInTemplateHeaderLogo,
	SignInTemplateRow,
	SignInTemplateCol,
	SignInTemplateFormGroupLinks,
	SignInTemplateFormGroupLink,
	SignInTemplateContainerFrame,
} from './SignInTemplate.styled'
import { baseTheme } from 'modules/Theme/styled'
import SKFullLogo from 'assets/icons/SKFullLogo.svg'
import ConvosFullLogo from 'assets/icons/ConvosFullLogo.svg'
import { Text } from 'components/Text'
import { translate } from 'i18n'

const SignInTemplate = ({ title, subtitle, children }: SignInTemplateProps) => {
	return (
		<SignInTemplateContainer>
			<SignInTemplateContainerFrame>
				<SignInTemplateRow>
					<SignInTemplateCol
						xs={{ span: 20 }}
						sm={{ span: 20 }}
						md={{ span: 12 }}
						lg={{ span: 12 }}
						xl={{ span: 8 }}
						xxl={{ span: 8 }}
						offset={2}
						style={{
							backgroundColor: baseTheme.colors.white,
							padding: '30px',
							borderRadius: '10px',
						}}
					>
						<SignInTemplateHeaderContainer>
							<SignInTemplateHeaderLogo src={SKFullLogo} />
							<SignInTemplateHeaderLogo src={ConvosFullLogo} />

							{title && (
								<Text text={title} preset="h2" style={{ marginTop: 50 }} />
							)}
							{subtitle && (
								<Text
									text={subtitle}
									color={baseTheme.colors.fontSecondary}
									style={{ marginBottom: 45, fontSize: '18px' }}
								/>
							)}
						</SignInTemplateHeaderContainer>

						{children}

						<SignInTemplateFormGroupLinks>
							<SignInTemplateFormGroupLink
								text={'Help'}
								onClick={() => window.open(translate('login.help'), '_blank')}
							/>
							<SignInTemplateFormGroupLink
								text={'Privacy'}
								onClick={() => window.open(translate('login.terms'), '_blank')}
							/>
							<SignInTemplateFormGroupLink
								text={'Terms'}
								onClick={() =>
									window.open(translate('login.privacy'), '_blank')
								}
							/>
						</SignInTemplateFormGroupLinks>
					</SignInTemplateCol>
				</SignInTemplateRow>
			</SignInTemplateContainerFrame>
		</SignInTemplateContainer>
	)
}

export default SignInTemplate
